'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dGroupings$0024 from "./presto.-List-Groupings$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002463 from "./presto.-Presto-Router$$anon$63.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$62() {
  this.bli = null;
  this.bla = null;
  this.blb = false;
  this.blj = null;
  this.blk = false;
  this.bln = null;
  this.blg = null;
  this.blh = false;
  this.blc = null;
  this.bld = false;
  this.ble = null;
  this.blf = false;
  this.bll = false;
  this.blm = false;
  this.bli = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bln = "ListGroupings";
}
export { $c_Lpresto_PrestoRouter$$anon$62 as $c_Lpresto_PrestoRouter$$anon$62 };
$p = $c_Lpresto_PrestoRouter$$anon$62.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$62;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$62() {
}
export { $h_Lpresto_PrestoRouter$$anon$62 as $h_Lpresto_PrestoRouter$$anon$62 };
$h_Lpresto_PrestoRouter$$anon$62.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bli;
});
$p.L = (function() {
  if ((!this.blb)) {
    this.bla = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.blb = true;
  }
  return this.bla;
});
$p.O = (function() {
  if ((!this.blk)) {
    this.blj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.blk = true;
  }
  return this.blj;
});
$p.E = (function() {
  return this.bln;
});
$p.t = (function() {
  if ((!this.blh)) {
    this.blg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.blh = true;
  }
  return this.blg;
});
$p.M = (function() {
  if ((!this.bld)) {
    this.blc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bld = true;
  }
  return this.blc;
});
$p.Q = (function() {
  if ((!this.blf)) {
    this.ble = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002463.$c_Lpresto_PrestoRouter$$anon$63();
    this.blf = true;
  }
  return this.ble;
});
$p.w = (function() {
  if ((!this.blm)) {
    this.bll = false;
    this.blm = true;
  }
  return this.bll;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee454) => ((p) => \u03b4scrutinee454))($j_presto$002e$002dList$002dGroupings$0024.$m_Lpresto_ListGroupings$())));
});
var $d_Lpresto_PrestoRouter$$anon$62 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$62, "presto.PrestoRouter$$anon$62", ({
  Ov: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$62 as $d_Lpresto_PrestoRouter$$anon$62 };
//# sourceMappingURL=presto.-Presto-Router$$anon$62.js.map
